'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Col = require('react-bootstrap/lib/Col');

var _Col2 = _interopRequireDefault(_Col);

var _Grid = require('react-bootstrap/lib/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _InputGroup = require('react-bootstrap/lib/InputGroup');

var _InputGroup2 = _interopRequireDefault(_InputGroup);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _common = require('../common');

var _commonFormsy = require('../common-formsy');

var _utils = require('../../utils');

var _constants = require('../../constants');

var _commonPriorFundings = require('../common-prior-fundings');

var _GenericFeeRow = require('./GenericFeeRow');

var _GenericFeeRow2 = _interopRequireDefault(_GenericFeeRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var formatMoney = _utils.FormattingUtils.formatMoney;
var LIEN_ACTIONS = _constants.AppConstants.LIEN_ACTIONS;

var LegalFundingLienModalFormGroup = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(LegalFundingLienModalFormGroup, _Component);

  function LegalFundingLienModalFormGroup() {
    _classCallCheck(this, LegalFundingLienModalFormGroup);

    return _possibleConstructorReturn(this, (LegalFundingLienModalFormGroup.__proto__ || Object.getPrototypeOf(LegalFundingLienModalFormGroup)).apply(this, arguments));
  }

  _createClass(LegalFundingLienModalFormGroup, [{
    key: 'renderNonFlatFeeRow',
    value: function renderNonFlatFeeRow(fee, idx) {
      return _react2.default.createElement(_GenericFeeRow2.default, { key: idx, fee: fee, idx: idx, label: 'Fee' });
    }
  }, {
    key: 'renderFlatFeeRow',
    value: function renderFlatFeeRow(fee, idx) {
      var lien = this.props.lien;

      return _react2.default.createElement(_GenericFeeRow2.default, { key: idx, fee: fee, idx: lien.feesNonFlat().length + idx, label: 'Flat Fee' });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          addBuyout = _props.addBuyout,
          application = _props.application,
          currentAction = _props.currentAction,
          errorMessage = _props.errorMessage,
          lien = _props.lien,
          priorFunding = _props.priorFunding,
          publishedOrSelectedPresets = _props.publishedOrSelectedPresets,
          showOnly = _props.showOnly,
          agreement_date = lien.agreement_date,
          funding_amount = lien.funding_amount,
          interest_start_date = lien.interest_start_date,
          preset_contract_template = lien.preset_contract_template,
          calculatedPrincipal = lien.calculatedPrincipal,
          groupedPresets = publishedOrSelectedPresets(),
          defaultPresetContractTemplate = (0, _get3.default)(groupedPresets, '[0].templates[0].id', ''),
          isConfirmed = [LIEN_ACTIONS.revise, LIEN_ACTIONS.finalize].includes(currentAction);


      return _react2.default.createElement(
        _Grid2.default,
        { fluid: true },
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            'h3',
            null,
            'Contract Template'
          )
        ),
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(_commonFormsy.GroupedDropdown, {
            name: 'preset_contract_template',
            label: 'Contract Template',
            groupedOptions: groupedPresets,
            value: preset_contract_template || defaultPresetContractTemplate,
            required: true
          })
        ),
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            'h3',
            null,
            'Principal'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-group-merged' },
          _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(_commonFormsy.Input, {
              type: 'hidden',
              name: 'is_confirmed',
              value: isConfirmed
            }),
            application && _react2.default.createElement(_commonFormsy.Input, {
              type: 'hidden',
              name: 'link_application',
              value: application.id
            }),
            _react2.default.createElement(_commonFormsy.Input, {
              addonAfter: _react2.default.createElement(
                _InputGroup2.default.Addon,
                null,
                '$'
              ),
              name: 'funding_amount',
              label: 'Amount to Plaintiff',
              validations: {
                isNumeric: true,
                isPositive: true,
                isWithinDecimalPlaces: 2
              },
              validationErrors: {
                isNumeric: 'Amount to Plaintiff must be a valid amount.',
                isPositive: 'Amount to Plaintiff must be positive.',
                isWithinDecimalPlaces: 'Amount to Plaintiff can not have more than 2 decimal places.'
              },
              value: funding_amount,
              type: 'number',
              required: true
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-group-merged' },
          priorFunding ? _react2.default.createElement(_commonPriorFundings.PriorFundingFormGroup, {
            priorFunding: priorFunding,
            required: true
          }) : _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(
              'div',
              { className: 'form-group-content' },
              _react2.default.createElement(
                _Button2.default,
                { className: 'button_add_buyout', bsStyle: 'link', disabled: showOnly, onClick: addBuyout },
                _react2.default.createElement(_common.Icon, { type: 'plus-square-o' }),
                'Add Buyout'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-group-merged' },
          lien.feesNonFlat().map(this.renderNonFlatFeeRow),
          _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(
              'div',
              { className: 'form-group-content' },
              _react2.default.createElement(
                _Button2.default,
                { className: 'button_add_fee', bsStyle: 'link', disabled: showOnly, onClick: lien.addNonFlatFee },
                _react2.default.createElement(_common.Icon, { type: 'plus-square-o' }),
                'Add fee'
              )
            )
          )
        ),
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            'div',
            { className: 'fees-total' },
            'Total ',
            _react2.default.createElement(
              'span',
              { className: 'number' },
              formatMoney(calculatedPrincipal(priorFunding))
            )
          )
        ),
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            'h3',
            null,
            'Flat Fees'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-group-merged' },
          lien.feesFlat().map(this.renderFlatFeeRow),
          _react2.default.createElement(
            _Row2.default,
            null,
            _react2.default.createElement(
              'div',
              { className: 'form-group-content' },
              _react2.default.createElement(
                _Button2.default,
                { className: 'button_add_flat_fee', bsStyle: 'link', disabled: showOnly, onClick: lien.addFlatFee },
                _react2.default.createElement(_common.Icon, { type: 'plus-square-o' }),
                'Add flat fee'
              )
            )
          )
        ),
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            'h3',
            null,
            'Contract Dates'
          )
        ),
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            'div',
            { className: 'form-group-merged' },
            _react2.default.createElement(
              _Row2.default,
              null,
              _react2.default.createElement(_commonFormsy.DateInput, {
                name: 'agreement_date',
                label: 'Agreement Date',
                positionTop: true,
                value: agreement_date,
                required: true
              })
            ),
            _react2.default.createElement(
              _Row2.default,
              null,
              _react2.default.createElement(_commonFormsy.DateInput, {
                name: 'interest_start_date',
                label: 'Interest Start Date',
                positionTop: true,
                value: interest_start_date,
                required: true
              })
            )
          )
        ),
        errorMessage && _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            _Col2.default,
            null,
            _react2.default.createElement(
              'p',
              { className: 'text-danger' },
              errorMessage
            )
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return LegalFundingLienModalFormGroup;
}(_react.Component), _class2.propTypes = {
  addBuyout: _propTypes2.default.func.isRequired,
  application: _propTypes2.default.object,
  currentAction: _propTypes2.default.string,
  errorMessage: _propTypes2.default.string,
  lien: _propTypes2.default.object,
  priorFunding: _propTypes2.default.object,
  publishedOrSelectedPresets: _propTypes2.default.func,
  showOnly: _propTypes2.default.bool
}, _temp)) || _class) || _class;

var _default = LegalFundingLienModalFormGroup;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(formatMoney, 'formatMoney', '/app/src/components/page-case/LegalFundingLienModalFormGroup.js');
  reactHotLoader.register(LIEN_ACTIONS, 'LIEN_ACTIONS', '/app/src/components/page-case/LegalFundingLienModalFormGroup.js');
  reactHotLoader.register(LegalFundingLienModalFormGroup, 'LegalFundingLienModalFormGroup', '/app/src/components/page-case/LegalFundingLienModalFormGroup.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/LegalFundingLienModalFormGroup.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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